import React, { useState } from 'react'
import SimpleSlider from '../components/SimpleSlider'
import { Link } from 'react-router-dom'
import axios from "axios"
const Home = () => {
    // .........................................
    const [formdata, setFormdata] = useState({
        username: "",
        email: "",
        service: "",
        date: "",
        message: "",
    })
    const OnchangeData = (e) => {
        setFormdata({
            ...formdata,
            [e.target.name]: e.target.value
        })
    }
    // ...............
    const Onhandleform = (e) => {
        e.preventDefault();

        axios({
          method: "post",
          url: "${process.env.REACT_APP_API_URL}/booking",
          data: formdata,
        }).then((res) => {
          alert(res.data);
        });
    }
    // ...................................
    return (
        <>
            {/* <!-- Carousel Start --> */}
            <div class="container-fluid p-0 mb-5">
                <div id="header-carousel" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img class="w-100" src="img/carousel-bg-1.jpg" alt="Image" />
                            <div class="carousel-caption d-flex align-items-center">
                                <div class="container">
                                    <div class="row align-items-center justify-content-center justify-content-lg-start">
                                        <div class="col-10 col-lg-7 text-center text-lg-start">
                                            <h6 class="text-white text-uppercase mb-3 animated slideInDown">// Car Washing Service //</h6>
                                            <h1 class="display-3 text-white mb-4 pb-3 animated slideInDown">Professional Car Washing Service</h1>
                                            <Link to="/shop/" class="btn btn-primary py-3 px-5 animated slideInDown">Book Washing Service<i class="fa fa-arrow-right ms-3"></i></Link>
                                        </div>
                                        <div class="col-lg-5 d-none d-lg-flex animated zoomIn">
                                            <img class="img-fluid" src="img/carousel-1.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <img class="w-100" src="img/carousel-bg-2.jpg" alt="Image" />
                            <div class="carousel-caption d-flex align-items-center">
                                <div class="container">
                                    <div class="row align-items-center justify-content-center justify-content-lg-start">
                                        <div class="col-10 col-lg-7 text-center text-lg-start">
                                            <h6 class="text-white text-uppercase mb-3 animated slideInDown">// Car Washing Service //</h6>
                                            <h1 class="display-3 text-white mb-4 pb-3 animated slideInDown">Professional Car Washing Service</h1>
                                            <Link to="/shop/" class="btn btn-primary py-3 px-5 animated slideInDown">Book Washing Service<i class="fa fa-arrow-right ms-3"></i></Link>
                                        </div>
                                        <div class="col-lg-5 d-none d-lg-flex animated zoomIn">
                                            <img class="img-fluid" src="img/carousel-2.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#header-carousel"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#header-carousel"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
            {/* <!-- Carousel End --> */}


            {/* <!-- Service Start --> */}
            <div class="container-xxl py-5">
                <div class="container">
                    <div class="row g-4">
                        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div class="d-flex py-5 px-4">
                                <i class="fa fa-certificate fa-3x text-primary flex-shrink-0"></i>
                                <div class="ps-4">
                                    <h5 class="mb-3">Quality Servicing</h5>
                                    <p>We provide top-quality car washing services with attention to detail and customer satisfaction</p>
                                    {/* <a class="text-secondary border-bottom" href="">Read More</a> */}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div class="d-flex bg-light py-5 px-4">
                                <i class="fa fa-users-cog fa-3x text-primary flex-shrink-0"></i>
                                <div class="ps-4">
                                    <h5 class="mb-3">Expert Workers</h5>
                                    <p>We provide top-quality car washing services with attention to detail and customer satisfaction</p>
                                    {/* <a class="text-secondary border-bottom" href="">Read More</a> */}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div class="d-flex py-5 px-4">
                                <i class="fa fa-tools fa-3x text-primary flex-shrink-0"></i>
                                <div class="ps-4">
                                    <h5 class="mb-3">Modern Equipment</h5>
                                    <p>We provide top-quality car washing services with attention to detail and customer satisfaction</p>
                                    {/* <a class="text-secondary border-bottom" href="">Read More</a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Service End --> */}


            {/* <!-- About Start --> */}
            <div class="container-xxl py-5">
                <div class="container">
                    <div class="row g-5">
                        <div class="col-lg-6 pt-4" style={{ minHeight: "400px" }}>
                            <div class="position-relative h-100 wow fadeIn" data-wow-delay="0.1s">
                                <img class="position-absolute img-fluid w-100 h-100" src="img/about.jpg" style={{ objectFit: "cover" }} alt="" />
                                <div class="position-absolute top-0 end-0 mt-n4 me-n4 py-4 px-5" style={{ background: "rgba(0, 0, 0, .08)" }}>
                                    <h1 class="display-4 text-white mb-0">15 <span class="fs-4">Years</span></h1>
                                    <h4 class="text-white">Experience</h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <h6 class="text-primary text-uppercase">// About Us //</h6>
                            <h1 class="mb-4"><span class="text-primary">UrbanWash</span> Is The Best Place For Your Auto Care</h1>
                            <p class="mb-4">UrbanWash has been serving customers with professional car washing services for over 15 years. We use eco-friendly products and modern techniques to ensure your vehicle looks its best while protecting the environment.</p>
                            <div class="row g-4 mb-3 pb-3">
                                <div class="col-12 wow fadeIn" data-wow-delay="0.1s">
                                    <div class="d-flex">
                                        <div class="bg-light d-flex flex-shrink-0 align-items-center justify-content-center mt-1" style={{ width: "45px", height: "45px" }}>
                                            <span class="fw-bold text-secondary">01</span>
                                        </div>
                                        <div class="ps-3">
                                            <h6>Professional & Expert</h6>
                                            <span>Our team consists of certified professionals with extensive training in car care</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 wow fadeIn" data-wow-delay="0.3s">
                                    <div class="d-flex">
                                        <div class="bg-light d-flex flex-shrink-0 align-items-center justify-content-center mt-1" style={{ width: "45px", height: "45px" }}>
                                            <span class="fw-bold text-secondary">02</span>
                                        </div>
                                        <div class="ps-3">
                                            <h6>Quality Servicing Center</h6>
                                            <span>Our team consists of certified professionals with extensive training in car care</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 wow fadeIn" data-wow-delay="0.5s">
                                    <div class="d-flex">
                                        <div class="bg-light d-flex flex-shrink-0 align-items-center justify-content-center mt-1" style={{ width: "45px", height: "45px" }}>
                                            <span class="fw-bold text-secondary">03</span>
                                        </div>
                                        <div class="ps-3">
                                            <h6>Awards Winning Workers</h6>
                                            <span>Our team consists of certified professionals with extensive training in car care</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <a href="" class="btn btn-primary py-3 px-5">Read More<i class="fa fa-arrow-right ms-3"></i></a> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- About End --> */}


            {/* <!-- Fact Start --> */}
            <div class="container-fluid fact bg-dark my-5 py-5">
                <div class="container">
                    <div class="row g-4">
                        <div class="col-md-6 col-lg-3 text-center wow fadeIn" data-wow-delay="0.1s">
                            <i class="fa fa-check fa-2x text-white mb-3"></i>
                            <h2 class="text-white mb-2" data-toggle="counter-up">1234</h2>
                            <p class="text-white mb-0">Years Experience</p>
                        </div>
                        <div class="col-md-6 col-lg-3 text-center wow fadeIn" data-wow-delay="0.3s">
                            <i class="fa fa-users-cog fa-2x text-white mb-3"></i>
                            <h2 class="text-white mb-2" data-toggle="counter-up">1234</h2>
                            <p class="text-white mb-0">Expert Technicians</p>
                        </div>
                        <div class="col-md-6 col-lg-3 text-center wow fadeIn" data-wow-delay="0.5s">
                            <i class="fa fa-users fa-2x text-white mb-3"></i>
                            <h2 class="text-white mb-2" data-toggle="counter-up">1234</h2>
                            <p class="text-white mb-0">Satisfied Clients</p>
                        </div>
                        <div class="col-md-6 col-lg-3 text-center wow fadeIn" data-wow-delay="0.7s">
                            <i class="fa fa-car fa-2x text-white mb-3"></i>
                            <h2 class="text-white mb-2" data-toggle="counter-up">1234</h2>
                            <p class="text-white mb-0">Compleate Projects</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Fact End --> */}


            {/* <!-- Service Start --> */}
            <div class="container-xxl service py-5">
                <div class="container">
                    <div class="text-center wow fadeInUp" data-wow-delay="0.1s">
                        <h6 class="text-primary text-uppercase">// Our Services //</h6>
                        <h1 class="mb-5">Explore Our Services</h1>
                    </div>
                    <div class="row g-4 wow fadeInUp" data-wow-delay="0.3s">
                        <div class="col-lg-4">
                            <div class="nav w-100 nav-pills me-4">
                                <button class="nav-link w-100 d-flex align-items-center text-start p-4 mb-4 active" data-bs-toggle="pill" data-bs-target="#tab-pane-1" type="button">
                                    <i class="fa fa-car-side fa-2x me-3"></i>
                                    <h4 class="m-0">Exterior Wash</h4>
                                </button>
                                <button class="nav-link w-100 d-flex align-items-center text-start p-4 mb-4" data-bs-toggle="pill" data-bs-target="#tab-pane-2" type="button">
                                    <i class="fa fa-car fa-2x me-3"></i>
                                    <h4 class="m-0">Interior Cleaning</h4>
                                </button>
                                <button class="nav-link w-100 d-flex align-items-center text-start p-4 mb-4" data-bs-toggle="pill" data-bs-target="#tab-pane-3" type="button">
                                    <i class="fa fa-cog fa-2x me-3"></i>
                                    <h4 class="m-0">Premium Detailing</h4>
                                </button>
                                <button class="nav-link w-100 d-flex align-items-center text-start p-4 mb-0" data-bs-toggle="pill" data-bs-target="#tab-pane-4" type="button">
                                    <i class="fa fa-oil-can fa-2x me-3"></i>
                                    <h4 class="m-0">Tire & Wheel Care</h4>
                                </button>
                            </div>
                        </div>
                        <div class="col-lg-8">
                            <div class="tab-content w-100">
                                <div class="tab-pane fade show active" id="tab-pane-1">
                                    <div class="row g-4">
                                        <div class="col-md-6" style={{ minHeight: "350px" }}>
                                            <div class="position-relative h-100">
                                                <img class="position-absolute img-fluid w-100 h-100" src="img/service-1.jpg"
                                                    style={{ objectFit: "cover" }} alt="" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <h3 class="mb-3">Professional Car Washing Services</h3>
                                            <p class="mb-4">Our comprehensive car washing service includes exterior wash, tire cleaning, and window polishing. We use premium eco-friendly products and advanced techniques to give your vehicle a showroom shine while protecting its paint and finish. Our expert team ensures every detail is perfect.</p>
                                            <p><i class="fa fa-check text-success me-3"></i>Exterior Wash & Polish</p>
                                            <p><i class="fa fa-check text-success me-3"></i>Interior Vacuuming</p>
                                            <p><i class="fa fa-check text-success me-3"></i>Tire & Wheel Cleaning</p>
                                            {/* <a href="" class="btn btn-primary py-3 px-5 mt-3">Read More<i class="fa fa-arrow-right ms-3"></i></a> */}
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="tab-pane-2">
                                    <div class="row g-4">
                                        <div class="col-md-6" style={{ minHeight: "350px" }}>
                                            <div class="position-relative h-100">
                                                <img class="position-absolute img-fluid w-100 h-100" src="img/service-2.jpg"
                                                    style={{ objectFit: "cover" }} alt="" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <h3 class="mb-3">Interior Deep Cleaning Service</h3>
                                            <p class="mb-4">Our interior cleaning service includes vacuuming, dashboard polishing, seat cleaning, and air freshening. We use specialized tools and premium cleaning products to remove dirt, dust, and stains, leaving your car's interior fresh and spotless.</p>
                                            <p><i class="fa fa-check text-success me-3"></i>Complete Vacuuming</p>
                                            <p><i class="fa fa-check text-success me-3"></i>Dashboard & Console Cleaning</p>
                                            <p><i class="fa fa-check text-success me-3"></i>Seat & Upholstery Care</p>
                                            {/* <a href="" class="btn btn-primary py-3 px-5 mt-3">Read More<i class="fa fa-arrow-right ms-3"></i></a> */}
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="tab-pane-3">
                                    <div class="row g-4">
                                        <div class="col-md-6" style={{ minHeight: "350px" }}>
                                            <div class="position-relative h-100">
                                                <img class="position-absolute img-fluid w-100 h-100" src="img/service-3.jpg"
                                                    style={{ objectFit: "cover" }} alt="" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <h3 class="mb-3">Premium Car Detailing</h3>
                                            <p class="mb-4">Our premium detailing service provides comprehensive exterior and interior care including waxing, polishing, paint protection, and complete interior deep cleaning. Perfect for maintaining your vehicle's value and appearance.</p>
                                            <p><i class="fa fa-check text-success me-3"></i>Paint Protection & Waxing</p>
                                            <p><i class="fa fa-check text-success me-3"></i>Complete Interior Detailing</p>
                                            <p><i class="fa fa-check text-success me-3"></i>Premium Quality Products</p>
                                            {/* <a href="" class="btn btn-primary py-3 px-5 mt-3">Read More<i class="fa fa-arrow-right ms-3"></i></a> */}
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="tab-pane-4">
                                    <div class="row g-4">
                                        <div class="col-md-6" style={{ minHeight: "350px" }}>
                                            <div class="position-relative h-100">
                                                <img class="position-absolute img-fluid w-100 h-100" src="img/service-4.jpg"
                                                    style={{ objectFit: "cover" }} alt="" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <h3 class="mb-3">Tire & Wheel Care</h3>
                                            <p class="mb-4">Specialized tire and wheel cleaning service that removes brake dust, road grime, and restores the shine to your wheels. We use safe, non-corrosive products to protect your rims and tires while making them look brand new.</p>
                                            <p><i class="fa fa-check text-success me-3"></i>Wheel Deep Cleaning</p>
                                            <p><i class="fa fa-check text-success me-3"></i>Tire Shine & Protection</p>
                                            <p><i class="fa fa-check text-success me-3"></i>Brake Dust Removal</p>
                                            {/* <a href="" class="btn btn-primary py-3 px-5 mt-3">Read More<i class="fa fa-arrow-right ms-3"></i></a> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Service End --> */}


            {/* <!-- Booking Start --> */}
            <div class="container-fluid bg-secondary booking my-5 wow fadeInUp" data-wow-delay="0.1s">
                <div class="container">
                    <div class="row gx-5">
                        <div class="col-lg-6 py-5">
                            <div class="py-5">
                                <h1 class="text-white mb-4">Certified and Award Winning Car Repair Service Provider</h1>
                                <p class="text-white mb-0">UrbanWash is a certified and award-winning car washing service provider in India. We have been recognized for our excellence in customer service, use of premium products, and commitment to environmental sustainability. Our team of skilled professionals ensures your vehicle receives the best care possible.</p>
                            </div>
                        </div>
                        {/* <div class="col-lg-6">
                            <div class="bg-primary h-100 d-flex flex-column justify-content-center text-center p-5 wow zoomIn" data-wow-delay="0.6s">
                                <h1 class="text-white mb-4">Book For A Service</h1>
                                <form  onSubmit={Onhandleform} method="post">
                                    <div class="row g-3">
                                        <div class="col-12 col-sm-6">
                                            <input type="text" class="form-control border-0" placeholder="Enter your name (e.g., Arjun Mehta)" style={{ height: "55px" }}
                                                name="username"
                                                value={formdata.username}
                                                onChange={OnchangeData} required />
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <input type="email" class="form-control border-0" placeholder="Enter your email (e.g., arjun.mehta@gmail.com)" style={{ height: "55px" }}
                                                name="email"
                                                value={formdata.email}
                                                onChange={OnchangeData} />
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <select class="form-select border-0" style={{ height: "55px" }}
                                                name="service"
                                                value={formdata.service}
                                                onChange={OnchangeData}>

                                                <option selected>Select A Service</option>
                                                <option value="Car Washing">Car Washing</option>
                                                <option value="Car Repair">Car Repair</option>
                                                <option value="Car Maintenance">Car Maintenance</option>
                                            </select>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class="date" id="date1" data-target-input="nearest">
                                                <input type="date" className='form-control'
                                                    placeholder="Select service date" style={{ height: "55px" }}
                                                    name="date"
                                                    value={formdata.date}
                                                    onChange={OnchangeData} />
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <textarea class="form-control border-0" placeholder="Any special requests or instructions"
                                            name="message"
                                            value={formdata.message}
                                            onChange={OnchangeData}></textarea>
                                        </div>
                                        <div class="col-12">
                                            <button class="btn btn-secondary w-100 py-3" type="submit">Book Now</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            {/* <!-- Booking End --> */}


            {/* <!-- Team Start --> */}
            <div class="container-xxl py-5">
                <div class="container">
                    <div class="text-center wow fadeInUp" data-wow-delay="0.1s">
                        <h6 class="text-primary text-uppercase">// Our Technicians //</h6>
                        <h1 class="mb-5">Our Expert Technicians</h1>
                    </div>
                    <div class="row g-4">
                        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div class="team-item">
                                <div class="position-relative overflow-hidden">
                                    <img class="img-fluid" src="img/team-1.jpg" alt="" />
                                    <div class="team-overlay position-absolute start-0 top-0 w-100 h-100">
                                        <a class="btn btn-square mx-1" href=""><i class="fab fa-facebook-f"></i></a>
                                        <a class="btn btn-square mx-1" href=""><i class="fab fa-twitter"></i></a>
                                        <a class="btn btn-square mx-1" href=""><i class="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div class="bg-light text-center p-4">
                                    <h5 class="fw-bold mb-0">Full Name</h5>
                                    <small>Designation</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div class="team-item">
                                <div class="position-relative overflow-hidden">
                                    <img class="img-fluid" src="img/team-2.jpg" alt="" />
                                    <div class="team-overlay position-absolute start-0 top-0 w-100 h-100">
                                        <a class="btn btn-square mx-1" href=""><i class="fab fa-facebook-f"></i></a>
                                        <a class="btn btn-square mx-1" href=""><i class="fab fa-twitter"></i></a>
                                        <a class="btn btn-square mx-1" href=""><i class="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div class="bg-light text-center p-4">
                                    <h5 class="fw-bold mb-0">Full Name</h5>
                                    <small>Designation</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div class="team-item">
                                <div class="position-relative overflow-hidden">
                                    <img class="img-fluid" src="img/team-3.jpg" alt="" />
                                    <div class="team-overlay position-absolute start-0 top-0 w-100 h-100">
                                        <a class="btn btn-square mx-1" href=""><i class="fab fa-facebook-f"></i></a>
                                        <a class="btn btn-square mx-1" href=""><i class="fab fa-twitter"></i></a>
                                        <a class="btn btn-square mx-1" href=""><i class="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div class="bg-light text-center p-4">
                                    <h5 class="fw-bold mb-0">Full Name</h5>
                                    <small>Designation</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                            <div class="team-item">
                                <div class="position-relative overflow-hidden">
                                    <img class="img-fluid" src="img/team-4.jpg" alt="" />
                                    <div class="team-overlay position-absolute start-0 top-0 w-100 h-100">
                                        <a class="btn btn-square mx-1" href=""><i class="fab fa-facebook-f"></i></a>
                                        <a class="btn btn-square mx-1" href=""><i class="fab fa-twitter"></i></a>
                                        <a class="btn btn-square mx-1" href=""><i class="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div class="bg-light text-center p-4">
                                    <h5 class="fw-bold mb-0">Full Name</h5>
                                    <small>Designation</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Team End --> */}
            <SimpleSlider />
        </>

    )
}

export default Home
